<script lang="ts" setup>
import { inject, shallowRef } from 'vue';

import eventBus from 'lib/event-bus';

import { ButtonFilterProps } from './ButtonFilter.vue.d';
import Icon from '../icon/Icon.vue';

const props = withDefaults(defineProps<ButtonFilterProps>(), {
  tableName: 'datatable',
});

const emit = defineEmits<{
  showFilter: [payload: boolean];
}>();

const Preset = inject<Record<string, any>>('preset', {}).buttonfilter;

const showFilter = shallowRef<boolean>(false);

const toggleFilterPanel = (): void => {
  showFilter.value = !showFilter.value;
  emit('showFilter', showFilter.value);
  eventBus.emit('show-filter', {
    tableName: props.tableName,
    show: showFilter.value,
  });
};
</script>

<template>
  <button
    @click="toggleFilterPanel"
    v-bind="Preset?.root({ context: { active: showFilter } })"
    type="button"
  >
    <Icon
      v-bind="Preset?.icon({ context: { active: showFilter } })"
      :icon="showFilter ? 'filter-fill' : 'filter'"
      info="Filter"
      tooltip-pos="bottom"
    />
  </button>
</template>
